module.exports = __webpack_public_path__ + "static/media/worker_data_template.b0be8b9c.xls";